<template>
  <div class="barra mb-5">
    <v-progress-linear :value="zoom" class="progress" background-color="accent"></v-progress-linear>
    <v-btn class="left-icon" color="primary" dark fab x-small depressed>
      <v-icon>mdi-check</v-icon>
    </v-btn>
    <v-btn class="right-icon" :color="zoom === 100? 'primary' : 'accent'" fab x-small depressed>
      <v-icon :color="zoom === 100? '' : 'secondary'" >mdi-check</v-icon>
    </v-btn>
    <v-btn class="center-icon" :dark="zoom >= 50" :color="zoom >= 50 ? 'primary' : 'accent'" fab x-small depressed>
      <v-icon>mdi-check</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    zoom: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    calculatePosition() {
      if (this.zoom === 0) {
        return 'left: 0'
      }
      if (this.zoom === 100) {
        return 'right: 0'
      }
      return 'left: calc(' + this.zoom + '% - 16px);'
    },
  },
}
</script>

<style>
.barra {
  position: relative;
  height: 32px;
}
.barra .left-icon {
  position: absolute;
  left: 0;
  top: 0;
}

.barra .right-icon {
  position: absolute;
  right: 0;
  top: 0;
}

.barra .center-icon {
  position: absolute;
  left: calc(50% - 16px);
  top: 0;
}

.barra .progress {
  position: absolute;
  top: 50%;
}
</style>
